'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('ContractorguideCtrl', ['$scope', '$filter', '$sce', '$log', function ($scope, $filter, $sce, $log) {
		$scope.data = contractorData.data;
		$scope.stepsData = contractorData.steps;
		$scope.steps = [];
		$scope.urlParams = {
			type: '',
			url: ''
		};
		$scope.currentStep = {};

		var searchObjType = '';
		var searchObj = '';
		var queryString = '';

		function parseSearch() {
			queryString = window.location.search;
			let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

			if (typeof (pairs[0]) !== 'undefined' && pairs.length > 0) {
				searchObjType = pairs[0];
				searchObj = pairs[1];
			}
		}
		parseSearch();

		function setQueryData() {
			queryString = '?' + formatHistoryQuery();
			history.pushState("", document.title, window.location.pathname + queryString);
		}

		function formatHistoryQuery() {
			let el = [];
			for (var i in $scope.urlParams) {
				if (typeof ($scope.urlParams[i]) !== 'undefined' && $scope.urlParams[i] !== '') {
					el.push($scope.urlParams[i]);
				}
			}
			return el.join('&');
		}

		$scope.gotoStep = function (currentStepKey) {
			let step = $filter('filter')($scope.steps, {key: currentStepKey}, true);
			if (typeof (step) !== 'undefined' && step.length > 0) {
				let currentStep = step[0];
				$scope.step = currentStep;
				$scope.urlParams.url = currentStep.url;
				$scope.setCurrent(currentStep);
				setQueryData();
				$scope.markPreviousStepsAsCompleted(currentStep);
			}
		};
		
		$scope.handleStepKeypress = function ($event, step) {
			console.log("testing");
			if ($event.key === 'Enter' || $event.key === ' ') {
				$scope.gotoStep(step.ord);
				$event.preventDefault();
			}
		};

		$scope.reset = function () {
			$scope.steps = [];
			$scope.urlParams = {
				type: '',
				url: ''
			};
			$scope.currentStep = {};
			setQueryData();
		};

		$scope.setType = function (type) {
			$scope.urlParams.type = type;
			$scope.steps = $scope.stepsData[type];
			$scope.gotoStep('first');
		};

		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		};

		$scope.setCurrent = function (currentStep) {
			for (let step in $scope.steps) {
				$scope.steps[step].current = false;
				if ($scope.steps[step].key === currentStep.key) {
					currentStep.current = true;
				}
			}
			$scope.currentStep = currentStep;
		};

		$scope.markPreviousStepsAsCompleted = function (currentStep) {
			let foundCurrent = false;
			for (let step in $scope.steps) {
				if ($scope.steps[step].key === currentStep.key) {
					foundCurrent = true;
				}
				if (foundCurrent) {
					$scope.steps[step].completed = false;
				} else {
					$scope.steps[step].completed = true;
				}
			}
		};

		$scope.init = function () {
			if (typeof (searchObjType) !== 'undefined' && typeof ($scope.stepsData[searchObjType]) !== 'undefined') {
				$scope.steps = $scope.stepsData[searchObjType];
				$scope.setType(searchObjType);
				let q = $filter('filter')($scope.steps, {url: searchObj}, true);

				if (typeof (q) !== 'undefined' && q.length > 0) {
					$scope.gotoStep(q[0].key);
				} else {
					$scope.gotoStep('first');
				}
			}
		};

		$scope.init();

	}]).directive('translateCheck', ['$filter', function ($filter) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				scope.$watch(attrs.ngBind, function (value) {
					if (value && value.startsWith('*')) {
						element.addClass('not-translated');
					} else {
						element.removeClass('not-translated');
					}
				});
			}
		};
	}])
